import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { getCookieDomain } from '../utils/login';
import prodConfig from './prod';
import testConfig from './test';
var proConfig = prodConfig.feixiangxingqiu;
if (getCookieDomain().includes('top100school.com')) {
  proConfig = prodConfig.top100;
}
var ENV = process.env.REACT_APP_ENV;
var config = function () {
  switch (ENV) {
    case 'online':
    case 'production':
      return _objectSpread({
        ENV: ENV
      }, proConfig);
    default:
      return _objectSpread({
        ENV: ENV
      }, testConfig);
  }
}();
export default config;